<template>
    <v-layout>
        <v-flex xs12>
            <v-tabs
                    v-model="active"
                    dark
            >
                <v-tab :key="0">
                    Optimization Saving
                </v-tab>
                <v-tab :key="1">
                    Digital Twins
                </v-tab>
                <v-tab :key="2">
                    Chiller Efficiency Surface
                </v-tab>

                <v-tab-item :keys="0">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-card flat>
                                <v-card-title class="primary headline white--text">
                                    Optimization Saving
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 md6>
                                            <value-box :value="kpiValues.cooling_load_total"
                                                       icon-class="mr-3"
                                                       unit="kWh"
                                                       title="Total Cooling Load"
                                                       icon="fa-temperature-low">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                            <value-box :value="kpiValues.duration"
                                                       icon-class="mr-3"
                                                       unit="hours"
                                                       title="Duration"
                                                       icon="fa-hourglass">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                            <value-box :value="kpiValues.simulated_energy_total"
                                                       icon-class="mr-3"
                                                       unit="kWh"
                                                       title="Projected Energy Consumption"
                                                       icon="fa-lightbulb">
                                            </value-box>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                            <value-box :value="kpiValues.energy_saved"
                                                       icon-class="mr-3"
                                                       unit="kWh"
                                                       title="Saving"
                                                       icon="fa-piggy-bank">
                                            </value-box>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>

                        </v-flex>
                        <v-flex xs12>
                            <v-card>
                                <v-card-title class="accent white--text title">
                                    Diagnostic Plots
                                </v-card-title>
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <vue-plotly disable-responsive :data="copData" :layout="copLayout" :options="{}"/>
                                        </v-flex>
                                        <v-flex xs12>
                                            <vue-plotly disable-responsive :data="powerData" :layout="powerLayout" :options="{}"/>
                                        </v-flex>
                                        <!--v-flex xs12>
                                            <vue-plotly disable-responsive :data="coolingLoadData" :layout="coolingLoadLayout" :options="{}"/>
                                        </v-flex-->
                                        <v-flex xs12>
                                            <vue-plotly disable-responsive :data="chwsTempData" :layout="chwsTempLayout" :options="{}"/>
                                        </v-flex>
                                        <v-flex xs12>
                                            <cooling-load-forecast-core :content="coolingLoadContent"></cooling-load-forecast-core>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
                <v-tab-item :keys="1">
                    <v-layout>
                        <v-flex xs12 v-if="active==1">
                            <power-forecast></power-forecast>
                        </v-flex>
                    </v-layout>
                </v-tab-item>
                <v-tab-item :keys="2">
                    <v-layout>
                        <v-flex xs12 v-if="active==2">
                            <power-forecast zaxis="Cooling_Load" yaxis="CDWR_Temp" title="Efficiency Surface"></power-forecast>
                        </v-flex>
                    </v-layout>
                </v-tab-item>

            </v-tabs>
        </v-flex>
    </v-layout>

</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {getResult} from '@/helper'
    import ValueBox from '../components/ValueBox'
    import PowerForecast from './PowerForecast'
    import CoolingLoadForecastCore from '../components/loadforecast/CoolingLoadForecastCore'

    export default {
        name: 'OptimizationSaving',
        components: { CoolingLoadForecastCore, PowerForecast, ValueBox, VuePlotly},
        computed: {
            facilityName() {
                return this.$store.state.pointsListStore.pointsList.facility_name;
            },

        },
        data() {
            return {
              active:0,
              startDate: "",
                loading: true,
                copData: [],
              copLayout: {
                  title: "Plant COP",
                xaxis: {title: "Time"},
                yaxis: {title: "Plant COP(kW)"},
              },
              powerData: [],
              powerLayout: {
                title: "Plant Power",
                xaxis: {title: "Time"},
                yaxis: {title: "Plant Power(kW)"},
              },
              chwsTempData: [],
              chwsTempLayout: {
                title: "Chilled Water Supply Temp",
                xaxis: {title: "Time"},
                yaxis: {title: "CHWS Temp (C)"}
              },
              coolingLoadData: [],
              coolingLoadContent: null,
              coolingLoadLayout: {
                title: "Plant Power",
                xaxis: {title: "Time"},
                yaxis: {title: "Cooling Load (kW)"},
              },

                kpiValues: {
                  'cooling_load_total': 0,
                  'duration': 0,
                  'simulated_energy_total': 0,
                  'energy_saved': 0
                }
            }
        },
        methods: {},
        mounted() {
            let me = this;
            getResult({
                facility_name: me.facilityName,
                result_name: 'Optimization comparison result'
            }).then(function (input) {
              let res = input.result[0].content
              console.log(res)
              me.kpiValues=res.summary  // populate kpiValues


                let result = res.result
                let copData = []
                copData.push(
                            {
                                x: result['timestamp'],
                                y: result["plant_cop_predicted"],
                                hovertext: result.timestamp,
                                name: "Original COP",
                                mode: "markers+lines",
                            }
                    )

                copData.push(
                            {
                                x: result['timestamp'],
                                y: result["plant_cop_simulated"],
                                hovertext: result.timestamp,
                                name: "Optimized COP",
                                mode: "markers+lines",
                            }
                )

                me.copData = copData


                let powerData = []
                powerData.push(
                            {
                                x: result['timestamp'],
                                y: result["predicted_power_adj"],
                                hovertext: result.timestamp,
                                name: "Original Power",
                                mode: "markers+lines",
                            }
                    )

                powerData.push(
                            {
                                x: result['timestamp'],
                                y: result["simulated_power_adj"],
                                hovertext: result.timestamp,
                                name: "Optimized Power",
                                mode: "markers+lines",
                            }
                    )

                me.powerData = powerData

                let coolingLoadData = []
                for (let i in ["cooling_load"]) {
                  let varName = "cooling_load"
                    coolingLoadData.push(
                            {
                                x: result['timestamp'],
                                y: result[varName],
                                hovertext: result.timestamp,
                                name: varName,
                                mode: "markers+lines",
                            }
                    )
                }
                me.coolingLoadData = coolingLoadData


              let chwsTempData = []
              let chws_df = res.chws_df
              for (let i in Object.keys(chws_df)){
                chwsTempData.push(
                  {
                    x: result['timestamp'],
                    y: chws_df[Object.keys(chws_df)[i]],
                    hovertext: result.timestamp,
                    name: Object.keys(chws_df)[i],
                    mode: "markers+lines"
                  }
                )
              }
              me.chwsTempData = chwsTempData

              me.coolingLoadContent = res.cooling_load_forecast
              me.startDate = res.start_date

                me.loading = false
            });
        }

    }
</script>

<style scoped>

</style>
